// components/contracts/ContractHeader.js
// Header con info contratto, badge status e azioni

import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { 
  ArrowLeft, Download, FileSignature, Trash2, Loader2
} from 'lucide-react';

const STATUS_CONFIG = {
  bozza: { label: 'Bozza', color: 'bg-gray-100 text-gray-700' },
  in_attesa_firma: { label: 'In attesa firma', color: 'bg-blue-100 text-blue-700' },
  documenti_caricati: { label: 'Documenti caricati', color: 'bg-amber-100 text-amber-700' },
  in_validazione: { label: 'In validazione', color: 'bg-purple-100 text-purple-700' },
  approvato: { label: 'Approvato', color: 'bg-green-100 text-green-700' },
  documenti_mancanti: { label: 'Documenti mancanti', color: 'bg-yellow-100 text-yellow-700' },
  respinto: { label: 'Respinto', color: 'bg-red-100 text-red-700' },
};

const ContractHeader = ({
  contract,
  onBack,
  onDownloadPdf,
  onOpenAppaltoModal,
  onDelete,
  generatingAppalto,
  isAdmin
}) => {
  const statusConfig = STATUS_CONFIG[contract.status] || {};

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          data-testid="back-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-1" />
          Indietro
        </Button>
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-h3">{contract.contract_number}</h1>
            <Badge className={statusConfig.color}>
              {statusConfig.label}
            </Badge>
          </div>
          <p className="text-body-small mt-1">
            {contract.lead?.first_name} {contract.lead?.last_name}
          </p>
        </div>
      </div>
      <div className="flex gap-2">
        <Button 
          variant="outline"
          onClick={onDownloadPdf}
          data-testid="download-pdf-btn"
        >
          <Download className="w-4 h-4 mr-2" />
          Scarica PDF
        </Button>
        
        <Button 
          className="btn-primary"
          onClick={onOpenAppaltoModal}
          disabled={generatingAppalto}
          data-testid="generate-appalto-btn"
        >
          {generatingAppalto ? (
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          ) : (
            <FileSignature className="w-4 h-4 mr-2" />
          )}
          Genera Contratto Appalto
        </Button>
        
        {isAdmin && (
          <Button 
            variant="outline"
            className="border-red-300 text-red-600 hover:bg-red-50"
            onClick={() => {
              if (window.confirm('Sei sicuro di voler eliminare questo contratto? Questa azione è irreversibile.')) {
                onDelete();
              }
            }}
            data-testid="delete-contract-btn"
          >
            <Trash2 className="w-4 h-4 mr-2" />
            Elimina
          </Button>
        )}
      </div>
    </div>
  );
};

export default ContractHeader;
